import type { RootState } from '@/_store/store';

export const selectPlaceSelectedToEdit = (state: RootState) =>
  state.places.placeSelectedToEdit;
